import React, { useEffect, useState } from 'react'
import './styles/support.scss'

const DEPARTMENTS = [
  { id: 'account', label: 'Account & Login', icon: 'fa-solid fa-user-shield', description: 'Password resets, verification, account access' },
  { id: 'payment', label: 'Payments & Withdrawals', icon: 'fa-solid fa-wallet', description: 'Deposits, withdrawals, transaction issues' },
  { id: 'casino', label: 'Casino & Games', icon: 'fa-solid fa-dice', description: 'Game issues, bonuses, casino queries' },
  { id: 'sports', label: 'Sports Betting', icon: 'fa-solid fa-futbol', description: 'Bet settlements, odds, sportsbook help' },
  { id: 'technical', label: 'Technical Support', icon: 'fa-solid fa-wrench', description: 'Bugs, errors, platform issues' },
]

const openTawk = (department) => {
  if (typeof window === 'undefined') return

  const api = window.Tawk_API
  if (!api) return

  try {
    api.setAttributes({
      department,
    }, () => {})
  } catch (_) {}

  if (typeof api.maximize === 'function') {
    api.maximize()
  } else {
    api.onLoad = () => api.maximize()
  }
}

const SupportCenterMain = () => {
  const [tawkReady, setTawkReady] = useState(false)

  useEffect(() => {
    window.scrollTo({ top: 120, behavior: 'smooth' })

    const checkReady = () => {
      if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
        setTawkReady(true)
      } else if (window.Tawk_API) {
        window.Tawk_API.onLoad = () => setTawkReady(true)
      }
    }

    checkReady()
    const timer = setTimeout(checkReady, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <section className='support-center-container'>
      <div className='support-center-card'>
        <div className='support-center-hero'>
          <i className='fa-solid fa-headset support-center-hero-icon' />
          <h2 className='support-center-title'>Live Support</h2>
          <p className='support-center-subtitle'>
            Our support team is available 24/7. Choose your topic and we'll connect you instantly.
          </p>
        </div>

        <div className='support-departments'>
          {DEPARTMENTS.map((dept) => (
            <button
              key={dept.id}
              className='support-dept-card'
              onClick={() => openTawk(dept.label)}
            >
              <i className={dept.icon + ' support-dept-icon'} />
              <div className='support-dept-info'>
                <span className='support-dept-label'>{dept.label}</span>
                <span className='support-dept-desc'>{dept.description}</span>
              </div>
              <i className='fa-solid fa-chevron-right support-dept-arrow' />
            </button>
          ))}
        </div>

        <div className='support-center-cta'>
          <button
            className='support-center-submit'
            onClick={() => openTawk('General')}
          >
            <i className='fa-solid fa-comment-dots' />
            Start Live Chat
          </button>
          {!tawkReady && (
            <p className='support-loading-note'>
              <i className='fa-solid fa-circle-notch fa-spin' style={{ marginRight: 6 }} />
              Connecting to support...
            </p>
          )}
        </div>
      </div>
    </section>
  )
}

export default SupportCenterMain
